import { z } from "zod";

export const DeploymentFormSchema = z.object({
    name: z.string().min(1, {
        message: "Must fill out"
    }),
    website: z.string(),
    bookingFolder: z.string(),
    adminFolder: z.string(),
    email: z.string().email({
        message: "Please enter a valid email.",
    }),
    databaseServer: z.string(),
    databaseName: z.string().min(1, {
        message: "Must fill out"
    }),
    databaseUser: z.string().min(1, {
        message: "Must fill out"
    }),
    databasePassword: z.string().min(20, {
        message: "Must be atleast 20 characters long"
    }),
})
